import { onError } from 'apollo-link-error';
import moment from 'moment';
import { Logger } from '../../telemetry/Logger';
import {
  ScenarioColumns,
  TelemetryScenarioErrorStatus,
  TelemetryScenarioStatus
} from '../../telemetry/TelemetryScenarioTracker.types';

export const createTelemetryErrorLink = () => {
  return onError(({ operation, networkError }) => {
    if (networkError) {
      const { operationName } = operation;

      const context = operation.getContext();

      const startTime = context.startTime;
      const endTime = moment();
      const elapsedTimeInMs =
        startTime && endTime
          ? moment.duration(endTime.diff(startTime)).asMilliseconds()
          : 0;

      const requestHeaders = context?.headers;
      const correlationId = requestHeaders?.['x-ms-correlationid'];

      Logger.logMiddleTierRequestScenario({
        [ScenarioColumns.ScenarioStatus]: TelemetryScenarioStatus.Failure,
        [ScenarioColumns.CorrelationId]: correlationId,
        operation: operationName,
        elapsed: elapsedTimeInMs,
        errorCode: TelemetryScenarioErrorStatus.NetworkError,
        error: networkError
      });
    }
  });
};
